"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.useMediaQueries = exports.subtractOnePixel = void 0;
var react_1 = __importStar(require("react"));
var design_tokens_1 = require("@kaizen/design-tokens");
var subtractOnePixel = function (breakpoint) {
    return "".concat(parseInt(breakpoint, 10) - 1, "px");
};
exports.subtractOnePixel = subtractOnePixel;
var useMediaQueries = function (propQueries) {
    if (propQueries === void 0) { propQueries = {}; }
    if (typeof window === "undefined") {
        return {
            queries: {
                isSmall: false,
                isMedium: false,
                isLarge: false,
                isMediumOrSmaller: false,
                isMediumOrLarger: true
            },
            components: {
                SmallOnly: function () { return react_1["default"].createElement(react_1["default"].Fragment, null); },
                MediumOnly: function () { return react_1["default"].createElement(react_1["default"].Fragment, null); },
                LargeOnly: function () { return react_1["default"].createElement(react_1["default"].Fragment, null); },
                MediumOrSmaller: function () { return react_1["default"].createElement(react_1["default"].Fragment, null); },
                MediumOrLarger: function (props) { return react_1["default"].createElement(react_1["default"].Fragment, null, props.children); }
            }
        };
    }
    var theme = (0, design_tokens_1.useTheme)();
    // The `addEventListener` calls blow up legacy Edge (<= v18/pre chromium),
    // so we disable the functionality of updating after page load.
    var isLegacyEdge = navigator.userAgent.match(/Edge/);
    var isUnsupportedSafari = window.matchMedia("").addEventListener === undefined;
    // ---------------------------------------
    // Create Kaizen breakpoint matches for initial state
    // ---------------------------------------
    var smallMatchMedia = (0, react_1.useMemo)(function () {
        return window.matchMedia("(max-width: ".concat((0, exports.subtractOnePixel)(theme.layout.breakpoints.medium), ")"));
    }, [theme.layout.breakpoints.medium]);
    var mediumMatchMedia = (0, react_1.useMemo)(function () {
        return window.matchMedia("(min-width: ".concat(theme.layout.breakpoints.medium, ") and (max-width: ").concat((0, exports.subtractOnePixel)(theme.layout.breakpoints.large), ")"));
    }, [theme.layout.breakpoints.large]);
    var largeMatchMedia = (0, react_1.useMemo)(function () { return window.matchMedia("(min-width: ".concat(theme.layout.breakpoints.large, ")")); }, [theme.layout.breakpoints.large]);
    var isSmall = smallMatchMedia.matches || false;
    var isMedium = mediumMatchMedia.matches || false;
    var isLarge = largeMatchMedia.matches || false;
    var _a = (0, react_1.useState)({
        isSmall: isSmall,
        isMedium: isMedium,
        isLarge: isLarge,
        isMediumOrSmaller: !isLarge,
        isMediumOrLarger: !isSmall
    }), kaizenMatches = _a[0], setKaizenMatches = _a[1];
    // ---------------------------------------
    // Create an event listener based on the medium breakpoint and update state whenever it changes
    // ---------------------------------------
    (0, react_1.useEffect)(function () {
        if (isLegacyEdge || isUnsupportedSafari) {
            return;
        }
        var updateMatches = function () {
            var isSmallAfterUpdate = smallMatchMedia.matches || false;
            var isMediumAfterUpdate = mediumMatchMedia.matches || false;
            var isLargeAfterUpdate = largeMatchMedia.matches || false;
            setKaizenMatches({
                isSmall: isSmallAfterUpdate,
                isMedium: isMediumAfterUpdate,
                isLarge: isLargeAfterUpdate,
                isMediumOrSmaller: !isLargeAfterUpdate,
                isMediumOrLarger: !isSmallAfterUpdate
            });
        };
        mediumMatchMedia.addEventListener("change", updateMatches, true);
        return function () {
            mediumMatchMedia.removeEventListener("change", updateMatches);
        };
    }, []);
    // ---------------------------------------
    // Create custom queries matches for initial state
    // ---------------------------------------
    var customQueryMatchMedias = new Map();
    var customQueryMatches = {};
    new Map(Object.entries(propQueries)).forEach(function (queryString, queryName) {
        var matchMedia = window.matchMedia(queryString);
        customQueryMatches[queryName] = matchMedia.matches || false;
        // Store this matchMedia so that we can loop over it later and add event listeners
        customQueryMatchMedias.set(queryName, matchMedia);
    });
    var _b = (0, react_1.useState)(customQueryMatches), customMatches = _b[0], setCustomMatches = _b[1];
    // ---------------------------------------
    // Create an event listener for each custom query
    // ---------------------------------------
    (0, react_1.useEffect)(function () {
        if (isLegacyEdge || isUnsupportedSafari) {
            return;
        }
        var updateCustomMatches = function (matchMedia, queryName) {
            var _a;
            return setCustomMatches(__assign(__assign({}, customQueryMatches), (_a = {}, _a[queryName] = matchMedia.matches || false, _a)));
        };
        var allEventListeners = new Map();
        customQueryMatchMedias.forEach(function (matchMedia, queryName) {
            // Store this method so that we can reference it in the cleanup function below
            var updateCustomMatchesForQuery = function () {
                updateCustomMatches(matchMedia, queryName);
            };
            allEventListeners.set(matchMedia, updateCustomMatchesForQuery);
            // Add the event listener
            matchMedia.addEventListener("change", updateCustomMatchesForQuery, true);
        });
        return function () {
            allEventListeners.forEach(function (eventListener, matchMedia) {
                matchMedia.removeEventListener("change", eventListener);
            });
        };
    }, []);
    var kaizenComponents = {
        SmallOnly: function (props) { return (react_1["default"].createElement(react_1["default"].Fragment, null, kaizenMatches.isSmall && props.children)); },
        MediumOnly: function (props) { return (react_1["default"].createElement(react_1["default"].Fragment, null, kaizenMatches.isMedium && props.children)); },
        LargeOnly: function (props) { return (react_1["default"].createElement(react_1["default"].Fragment, null, kaizenMatches.isLarge && props.children)); },
        MediumOrSmaller: function (props) { return (react_1["default"].createElement(react_1["default"].Fragment, null, kaizenMatches.isMediumOrSmaller && props.children)); },
        MediumOrLarger: function (props) { return (react_1["default"].createElement(react_1["default"].Fragment, null, kaizenMatches.isMediumOrLarger && props.children)); }
    };
    // ---------------------------------------
    // Create custom query helper components
    // ---------------------------------------
    var customComponents = {};
    Object.keys(propQueries).map(function (key) {
        var componentName = key.charAt(0).toUpperCase() + key.slice(1);
        customComponents[componentName] = function (props) { return react_1["default"].createElement(react_1["default"].Fragment, null, customMatches[key] && props.children); };
    });
    return {
        queries: __assign(__assign({}, kaizenMatches), customQueryMatches),
        components: __assign(__assign({}, kaizenComponents), customComponents)
    };
};
exports.useMediaQueries = useMediaQueries;
//# sourceMappingURL=useMediaQueries.js.map